import { StyledConfigRow } from '../InsightsConfig.style';
import InsightSwitch from '../Inputs/InsightSwitch';
import InputNumber from 'components/base/InputNumber';
import { useContext } from 'react';
import InsightsFormStateContext from '../useFormState/form.state.context';
import { INSIGHTS_KEYS } from '../../../insights.keys';
import usePmViewer from 'common/hooks/pm/usePmViewer';

import { capitalize } from 'lodash';

const NoGitActivity = () => {
  const { getInsight, updateInsight, onToggleSwitch } = useContext(
    InsightsFormStateContext
  );
  const pmViewer = usePmViewer();
  const issuesText = capitalize(pmViewer.ticket.plural);

  const insight = getInsight(INSIGHTS_KEYS.ISSUES_NO_GIT_ACTIVITY);

  return (
    <StyledConfigRow>
      <InsightSwitch insight={insight} onClick={onToggleSwitch} />
      {issuesText} in progress are considered stuck after
      <InputNumber
        value={insight.days}
        onChange={value =>
          updateInsight(insight.key, {
            days: value
          })
        }
      />
      days with no git activity
    </StyledConfigRow>
  );
};

export default NoGitActivity;
